export default "__VITE_ASSET__e20b0efc__"